<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Anular venta</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="cerrar" :disabled="enviando"></button>
        </div>
        <div class="modal-body">
          <p v-if="nombreCliente || monto">
            {{ nombreCliente || 'Cliente' }}<template v-if="monto"> — Gs. {{ montoFormateado }}</template>
          </p>

          <div class="mb-3">
            <label class="form-label">Motivo de la anulación</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="motivo"
              :disabled="enviando"
              placeholder="Ej: Cliente solicitó anulación de la compra"
            ></textarea>
          </div>

          <div class="mb-2">
            <label class="form-label d-block">¿Se devolvió la mercadería?</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="devolvioSi"
                :value="true"
                v-model="devolvioMercaderia"
                :disabled="enviando"
              />
              <label class="form-check-label" for="devolvioSi">Sí</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="devolvioNo"
                :value="false"
                v-model="devolvioMercaderia"
                :disabled="enviando"
              />
              <label class="form-check-label" for="devolvioNo">No</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cerrar" :disabled="enviando">Cancelar</button>
          <button type="button" class="btn btn-danger" :disabled="!puedeConfirmar || enviando" @click="confirmar">
            <span v-if="enviando" class="spinner-border spinner-border-sm me-1"></span>
            Confirmar anulación
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: 'AnulacionVentaModal',
  props: {
    nombreCliente: { type: String, default: '' },
    monto: { type: Number, default: 0 },
    enviando: { type: Boolean, default: false }
  },
  emits: ['cerrado', 'confirmada'],
  data() {
    return {
      motivo: '',
      // sin preseleccionar: el operador debe elegir explícitamente
      // (backend exige devolvio_mercaderia sin default, ver SPEC RF3)
      devolvioMercaderia: null
    }
  },
  computed: {
    montoFormateado() {
      return Number(this.monto || 0).toLocaleString('es-PY')
    },
    puedeConfirmar() {
      return this.motivo.trim().length > 0 && typeof this.devolvioMercaderia === 'boolean'
    }
  },
  methods: {
    cerrar() {
      this.$emit('cerrado')
    },
    confirmar() {
      if (!this.puedeConfirmar) return
      this.$emit('confirmada', {
        motivo: this.motivo.trim(),
        devolvio_mercaderia: this.devolvioMercaderia
      })
    }
  }
}
</script>
